import axios from "axios"
import store from "../store"
import { getToken } from "./auth"// 这里做loading会调用store
import { Message, Notification } from "element-ui";

// create an axios instance

// const request = axios.create({
//   baseURL: window.global_config.BASE_URL, //api 配置路径  直接修改static 下的config.js
//   timeout: 5000, // request timeout
// });
const request = axios.create({
  //baseURL: '',
  baseURL: global_config.BASE_URL|| '', //api 配置路径  直接修改static 下的config.js
  //timeout: 50000, // request timeout
});


// Add a request interceptor 请求拦截器
request.interceptors.request.use(
  function (config) {    
    // Do something before request is sent
    store.dispatch("SetLoading", true);
    config.headers["Authorization"] = "Bearer" + " " + getToken();
    // config.headers['Content-Type'] = 'application/json'  
    // 關鍵修改：如果數據是 FormData，不要設置 Content-Type
    // 瀏覽器會自動設置正確的 multipart/form-data
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    // 如果是 FormData，讓瀏覽器自動設置
    return config;
  },
  function (error) {
    // Do something with request error
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000, // 显示时间, 毫秒。设为 0 则不会自动关闭
    });
    return Promise.reject(error);
  }
);

// response interceptor  响应拦截器
request.interceptors.response.use(
  (response) => {
    // !!! 关闭 loading !!!
    store.dispatch("SetLoading", false);
    const res = response.data;
    // debugger
    if (res == null) {
       return response;
    }
    if (res.status == undefined) {
       return response;
    }
    if (res.status !== 200 && res.status !== 120) {     
      if (res.status === 401) {
        //token 过期 直接跳到login 页面
        router.push({ path: "/login" });
      } else if (res.status == 210) {
        //debugger
      } else {
        Notification.error({
          title: "错误",
          message: res.message,
          customClass: "notificationWarningClass",
        });
      }      
    }
    return response;
  },
  (error) => {
    // !!! 关闭 loading !!!
    store.dispatch("SetLoading", false);
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000 /*5 * 1000*/, // 显示时间, 毫秒。设为 0 则不会自动关闭
    });
    return Promise.reject(error);
  }
);
export default request
